var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  inset: 0px;\n  z-index: 35;\n  pointer-events: none;\n  outline: none;\n"], ["\n  position: fixed;\n  inset: 0px;\n  z-index: 35;\n  pointer-events: none;\n  outline: none;\n"])));
var Backdrop = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  inset: 0px;\n  pointer-events: all;\n  background-color: rgba(0, 0, 0, 0.3);\n"], ["\n  position: absolute;\n  inset: 0px;\n  pointer-events: all;\n  background-color: rgba(0, 0, 0, 0.3);\n"])));
var BackdropContainer = function (_a) {
    var children = _a.children;
    return (React.createElement(Container, { "data-testid": "layer-backdropContainer" },
        React.createElement(Backdrop, { "data-testid": "layer-backdrop" }),
        children));
};
export default BackdropContainer;
var templateObject_1, templateObject_2;
